module.exports = __webpack_public_path__ + "static/media/steve.7009b39b.png";